export default {"src":"/login-app/[GIT_HASH]/_next/static/media/link.dcddb6aa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};